<div class="page">
    <app-step-progress [steps]="steps"></app-step-progress>
    <app-page-title [title]="'Identification Document Scan'"></app-page-title>
    <app-selected-test-info></app-selected-test-info>
    <div class="row">
        <div class="col-md-12">
            <p>Please upload an image of your identification document.</p>
            <p>The document must match the information you entered during registration. The image must show the following parts of the document:</p>
            <ul>
                <li>Photo</li>
                <li>Full name</li>
                <li>Birthday</li>
                <li>Document number</li>
                <li>Expiry date</li>
                <li>Signature (if there is a signature on the document)</li>
            </ul>
            <p>
                You can upload up to 2 images if you need to include an additional page or side of your document in order to show all required parts of it.
            </p>
            <div>
                Image requirements:
                <ul>
                    <li>JPEG format</li>
                    <li>10 MB or smaller</li>
                    <li>In colour, clear, and unedited</li>
                    <li>Shows the whole identification document</li>
                </ul>
            </div>
            <br />
        </div>
        <div>
            <p>
                <strong>
                    ********************<br />
                    IMPORTANT: Your registration is not confirmed until we approve your photo and ID upload. Please check your email in 1-2 business days to confirm your photo and ID submission acceptance. If you do not receive an email, please <a href="https://www.cael.ca/about-us/contact-us/">contact us</a>.<br />
                    <br />
                    If your photo or ID submission is rejected, you will be asked to send a new one. If you do not respond or send an acceptable photo or ID 48 hours before the test date, we will cancel and refund your test.
                    <br />********************
                </strong>
            </p>
        </div>
        <div class="col-md-12">
            <app-document-upload-form
                [regBlobDataTypeId]=RegBlobDataTypeEnum.OnlineScannedDocument
                (updateUploadStatus)="changeStatus()"
            ></app-document-upload-form>
            <div *ngIf="firstFileUploaded">
                <div class="my-5">
                    <div>
                        <h2>Additional Image</h2>
                        <p><strong>You can upload a second image if you need to include an additional page or side of your identification document to show all required parts.</strong></p>
                    </div>
                </div>
                <app-document-upload-form
                    [regBlobDataTypeId]=RegBlobDataTypeEnum.OnlineScannedDocument2
                    (updateUploadStatus)="changeStatus()"
                ></app-document-upload-form>
                <button
                    type="button"
                    class="btn btn-primary mt-5"
                    (click)=redirectNextStep()
                >Continue Registration</button>
            </div>
        </div>
    </div>
</div>
